import {
  IconColorSwatch,
  IconContrast2,
  IconGradienter,
  IconRulerMeasure,
  IconLayout,
  IconPhoto,
  IconBooks,
  IconArrowUpRight,
} from '@tabler/icons-react';
import type { StudioToolId } from '@/types/studio';

const TOOLS: Array<{
  id: StudioToolId;
  label: string;
  description: string;
  icon: typeof IconColorSwatch;
}> = [
  { id: 'palette', label: 'Palette', description: 'Compose & explore', icon: IconColorSwatch },
  {
    id: 'gradient',
    label: 'Gradient',
    description: 'Blend the possibilities',
    icon: IconGradienter,
  },
  { id: 'scale', label: 'Scale', description: 'Build a color system', icon: IconRulerMeasure },
  { id: 'contrast', label: 'Contrast', description: 'Make it accessible', icon: IconContrast2 },
  { id: 'playground', label: 'Playground', description: 'See it in the world', icon: IconLayout },
  { id: 'image', label: 'Image', description: 'Find colors in a picture', icon: IconPhoto },
  { id: 'library', label: 'Library', description: 'Keep your favorites', icon: IconBooks },
];

export function StudioNavigation({
  activeTool,
  onChange,
  libraryCount,
}: {
  activeTool: StudioToolId;
  onChange: (tool: StudioToolId) => void;
  libraryCount: number;
}) {
  return (
    <nav className="studio-tool-rail" aria-label="Color tools">
      <p className="studio-rail-label">YOUR WORKBENCH</p>
      <div className="studio-tool-list">
        {TOOLS.map((tool, index) => {
          const Icon = tool.icon;
          const active = tool.id === activeTool;
          return (
            <button
              key={tool.id}
              type="button"
              className="studio-tool-button"
              data-active={active || undefined}
              aria-current={active ? 'page' : undefined}
              title={`Press ${index + 1}`}
              aria-keyshortcuts={String(index + 1)}
              onClick={() => onChange(tool.id)}
            >
              <span className="studio-tool-icon" aria-hidden="true">
                <Icon />
              </span>
              <span className="studio-tool-copy">
                <strong>
                  {tool.label}
                  {tool.id === 'library' && libraryCount > 0 && (
                    <span className="studio-nav-count">{libraryCount}</span>
                  )}
                </strong>
                <small>{tool.description}</small>
              </span>
              <kbd>{index + 1}</kbd>
            </button>
          );
        })}
      </div>
      <div className="studio-rail-inspiration">
        <div className="studio-rail-color-art" aria-hidden="true">
          <i />
          <i />
          <i />
        </div>
        <strong>
          A little curiosity
          <br />
          goes a long way.
        </strong>
        <button type="button" onClick={() => onChange('library')}>
          Find a direction
          <IconArrowUpRight />
        </button>
      </div>
      <div className="studio-rail-note">
        <span className="studio-status-dot" aria-hidden="true" />
        <span>
          Local by design<small>Your colors stay with you.</small>
        </span>
      </div>
    </nav>
  );
}
